import { render, staticRenderFns } from "./ShowAllCollectionsToggle.vue?vue&type=template&id=08312d3f&scoped=true"
import script from "./ShowAllCollectionsToggle.vue?vue&type=script&lang=ts"
export * from "./ShowAllCollectionsToggle.vue?vue&type=script&lang=ts"
import style0 from "./ShowAllCollectionsToggle.vue?vue&type=style&index=0&id=08312d3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08312d3f",
  null
  
)

export default component.exports